import defaultArticleCover from "@/assets/images/defaults/article-cover-elan.svg";
import defaultUserAvatar from "@/assets/images/defaults/user-avatar.jpg";

export { defaultArticleCover, defaultUserAvatar };

export function applyImageFallback(event, fallback) {
  const image = event?.currentTarget || event?.target;
  if (!image || image.dataset?.fallbackApplied === "true") return;
  if (image.dataset) image.dataset.fallbackApplied = "true";
  image.src = fallback;
}

export const applyArticleCoverFallback = (event) => applyImageFallback(event, defaultArticleCover);
export const applyUserAvatarFallback = (event) => applyImageFallback(event, defaultUserAvatar);
